import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Cookie from 'js-cookie';
// config
import { config } from '../../config';
import { history } from '../../store';

// actions
import { getCustomerForImpersonation } from '../../actions/sofologist';
import { loginUser } from '../../actions/user';


// components
import GhostButton from '../../parts/GhostButton';
import MySofologyLogo from '../../layout/graphics/MySofologyLogo';
import SofologistHeader from '../../layout//SofologistHeader';
import OverlayLoader from '../../parts/OverlayLoader';
import CustomerMultiSelect from './CustomerMultiSelect';

// services
import asSofologist from '../../services/dataSources/asSofologist';

import { getUserCookies } from '../../services/cookieService';

const FIND_TYPES = {
  orderRef: {
    displayText: 'Reference number',
    placeHolder: '1194567/1',
    method: 'ORDERREF',
    requestObj: (state) => {
      const orderParts = state.customerFindInputValue.trim().split('/');
      return { SearchTerm: orderParts[0], orderRef: orderParts[0], orderNumber: orderParts[1] };
    }
  },
  email: {
    displayText: 'email address',
    placeHolder: 'username@domain.com',
    method: 'EMAIL',
    requestObj: state => ({ SearchTerm: state.customerFindInputValue.trim() })
  },
  phoneNumber: {
    displayText: 'phone number',
    placeHolder: '0344 481 8181',
    method: 'PHONE',
    requestObj: state => ({ SearchTerm: state.customerFindInputValue.replace(/\s/g, '').trim() })
  },
  address: {
    displayText: 'postcode',
    placeHolder: 'WA3 3UL',
    method: 'POSTCODE',
    requestObj: state => ({
      SearchTerm: state.customerFindInputValue.trim(),
      postCode: state.customerFindInputValue.trim()
    })
  }
};
class _SofologistCustomerFinder extends Component {

  constructor(props) {
    super(props);
    this.state = {
      customerFindInputValue: '',
      customerFindType: 'orderRef',
      loading: false,
      selected: false,
      errors: false,
      foundCustomers: []
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFindCustomers = this.handleFindCustomers.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handleHouseInputChange = this.handleHouseInputChange.bind(this);
    this.setFoundCustomers = this.setFoundCustomers.bind(this);
    this.handleSelectCustomer = this.handleSelectCustomer.bind(this);
    const user = getUserCookies();
    if(user && user.retailExperienceUser) {
       // partial login for header information - will not contain auth etc.
       // although you can get this by making the cookieAuth call with the cookie.
      props.loginUser(user);
    }
  }

  setFoundCustomers(customers = []) {
    this.setState({
      foundCustomers: customers
    });
  }

  handleHouseInputChange() {
    this.setState({
      customerHouseNumber: this.customerHouseInput.value
    });
  }

  handleTypeChange() {
    this.setState({
      customerFindType: this.customerFindTypeInput.value
    });
  }

  noDetailsFound() {
    this.setState({
      loading: false,
      errors: 'Could not find a customer for those details. Please contact customer service.'
    });
  }

  handleErrors() {
    this.noDetailsFound();
  }

  handleInputChange() {
    this.setState({
      customerFindInputValue: this.customerFindInput.value
    });
  }

  handleSelectCustomer(customer) {
    this.setState({ selected: true });
    // get username for user
    asSofologist.get(`${config.URLS.MY_SOFOLOGY_API}/impersonation/getusername/${customer.guid}`)
      .then((res) => {
        if (!res.data || res.data === null) return Promise.reject();
        const retailExperienceUser = {
          username: res.data,
          userId: customer.guid,
          isLoggedIn: true
        };
        const cookieConfig = { domain: config.APP_INFO.COOKIE_DOMAIN, expires: 365 };
        Cookie.set('sofologyUser', { token: null }, cookieConfig);
        Cookie.set('retailExperience.user', retailExperienceUser, cookieConfig);
        return history.push('/');
      })
      .catch(() => {
        this.setState({ selected: false, errors: ['Failed to impersonate customer'] });
      });
  }

  handleFindCustomers(e) {
    e.preventDefault();
    this.setState({ loading: true, errors: false, foundCustomers: [] });
    const { getCustomerForImpersonation } = this.props;
    const { customerFindType } = this.state;
    const request = FIND_TYPES[customerFindType].requestObj(this.state);

    getCustomerForImpersonation(request.SearchTerm, FIND_TYPES[customerFindType].method)
      .then((res) => {
        if(!(res.data && res.data.length))
          this.noDetailsFound();
        this.setFoundCustomers(res.data);
        this.setState({ loading: false });
      })
      .catch(() => this.handleErrors());
  }

  render() {
    const {
      customerFindInputValue, customerFindType,
      loading, errors, foundCustomers, selected
    } = this.state;

    return (
      <React.Fragment>
        <SofologistHeader />
        <OverlayLoader
          active={selected}
          background={'rgba(247, 247, 247, .8)'}
        />
        <div className="u-flex-center-both--col c-customer-finder u-padding-top">
          <div className="u-flex-center-both--col">
            <h1 className="admin-logo">
              <div className="">
                <MySofologyLogo textColor="black" />
                <div className="u-padding-bottom-micro">Admin</div>
              </div>
            </h1>

            <form
              style={{ maxWidth: '400px', position: 'relative' }}
              onSubmit={this.handleFindCustomers}
              method="post"
              className="form__admin  u-padding-x-small"
            >

              <OverlayLoader
                active={loading}
                background={'rgba(247, 247, 247, .8)'}
              />

              <fieldset className="form__group u-w-100">
                <label htmlFor="find-type">Select Identification Mode</label>
                <select
                  className="form__group__inputFields u-w-100"
                  id="find-type"
                  onChange={this.handleTypeChange}
                  ref={
                    (customerFindTypeInput) => { this.customerFindTypeInput = customerFindTypeInput; }
                  }
                  disabled={loading}
                  required
                >
                  {Object.keys(FIND_TYPES).map(key => <option key={`id-mode-option-${key}`} value={key}>{FIND_TYPES[key].displayText}</option>)}
                </select>
              </fieldset>


              <fieldset className="form__group u-w-100">
                <label htmlFor="orderid">
                  Enter customer {FIND_TYPES[customerFindType].displayText}
                </label>
                <input
                  className="form__group__inputFields u-border-box"
                  id="orderid"
                  placeholder={`eg: ${FIND_TYPES[customerFindType].placeHolder}`}
                  value={customerFindInputValue}
                  ref={(customerFindInput) => { this.customerFindInput = customerFindInput; }}
                  onChange={this.handleInputChange}
                  disabled={loading}
                  required
                />
              </fieldset>

              <GhostButton
                text="Find Customer"
                onBtnClick={this.handleFindCustomers}
                disabled={loading}
                extraClass="u-w-100 u-padding-y-small u-margin-top-small"
              />

              <div
                className="errors"
              >
                {loading ? null : errors}
              </div>

            </form>

          </div>
        </div>
        <CustomerMultiSelect
          customers={foundCustomers}
          onClose={this.setFoundCustomers}
          onSelect={this.handleSelectCustomer}
        />
      </React.Fragment>);
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  getCustomerForImpersonation, loginUser
}, dispatch);

export default connect(null, mapDispatchToProps)(_SofologistCustomerFinder);



// WEBPACK FOOTER //
// ./src/pages/AdminPage/SofologistCustomerFinder.js